import { API, graphqlOperation } from 'aws-amplify'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { updateUser } from '../redux/app/actions'
import { useFetchFloorWardenRequests } from './FetchFloorWardenRequests'

const op = `mutation createUsageInfo($input: usageInfoInput) {
  createUsageInfo(input: $input) {
    pk
    sk
    ip
    email
  }
}`

const updateOccupant = `mutation updateOccupant($pk: ID!, $sk: String!, $version: Int!,  $input: updateOccupantInput) {
    updateOccupant(pk: $pk, sk: $sk, expectedVersion: $version, input: $input) {
        pk
        sk
        d1
        d2
        firstName
        lastName
        email
        lastLogin
        version
        primaryContact
        roles
        phone {
            number
        }
        workPhone {
            number
            extension
        }
        version
    }
}`

function useInit() {
    const [loading, setLoading] = useState([])
    const [error, setError] = useState([])
    const user = useSelector((state) => state.app.user)
    const sk = useSelector((state) => state.app.user.sk)

    useFetchFloorWardenRequests()

    const updateLastLogin = async () => {

        const _data = {
            pk: user.userId,
            sk: `OCCUPANCY#${user.userD1.split('#')[4]}`,
            version: user.version || 1,
            input: {
                lastLogin: Date.now()
            }
        }

        try {
           let res = await API.graphql(graphqlOperation(updateOccupant, _data))
            updateUser(res.data.updateOccupant)
        } catch (e) {
            console.log('error: ', e)
            throw Error(e)
        }
    }

    useEffect(() => {
        updateLastLogin()
    }, [sk])

    return { error, loading }
}

export default useInit
